export default function isValidDate(input: string) {
    return !isNaN(new Date(input).getTime());
}
